"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Loading;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Helper_1 = require("../Helper");
const react_i18next_1 = require("react-i18next");
const ThemeContext_1 = require("../ThemeContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        button: {
            alignItems: 'center',
            backgroundColor: THEME.Secondary,
            borderRadius: 2,
            flexDirection: 'row',
            justifyContent: 'center',
            paddingBottom: 8,
            paddingHorizontal: 12,
            paddingTop: 6
        },
        buttonText: {
            color: THEME.AlwaysWhite,
            fontSize: 16,
            fontWeight: '500'
        },
        secondaryButton: {
            justifyContent: 'center',
            marginVertical: 8,
            alignItems: 'center',
        },
        secondaryButtonText: {
            color: THEME.Secondary,
            fontSize: 16,
            fontWeight: '500'
        },
    });
};
function Loading(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    let message = props.message ?? t('common:messages.tryAgain');
    let retryable = props.retryable ?? false;
    let cancelable = props.cancelable ?? false;
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: 'center' }, children: [(props.loading) &&
                (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Secondary, size: props.size ?? 'large', style: {
                        marginBottom: Helper_1.Helper.isPlatformWeb ? 18 : 21,
                        marginTop: Helper_1.Helper.isPlatformWeb ? 20 : 22
                    } }), (props.error && !props.loading) &&
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 14 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: 18, color: THEME.Text }, children: message }) }), retryable &&
                            (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => props.onRetry(), style: ({ pressed }) => [
                                    styles.button,
                                    pressed ? { opacity: 0.6 } : null
                                ], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.buttonText, children: t('common:buttons.tryAgain') }) }), cancelable &&
                            (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => props.onCancel(), style: ({ pressed }) => [
                                    styles.secondaryButton,
                                    pressed ? { opacity: 0.6 } : null
                                ], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.secondaryButtonText, children: t('common:buttons.cancel') }) })] })] }));
}
;
